import React from 'react';
import { clsx } from 'clsx';

const Input = ({ 
  label, 
  icon: Icon, 
  error, 
  help,
  className = "", 
  containerClassName = "",
  ...props 
}) => {
  const inputId = props.id || props.name;

  return (
    <div className={containerClassName}>
      {label && (
        <label 
          htmlFor={inputId} 
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          {label}
        </label>
      )}
      
      <div className="relative">
        {Icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Icon className="w-5 h-5 text-gray-400" />
          </div>
        )}
        
        <input
          id={inputId}
          className={clsx(
            "input w-full",
            Icon ? "pl-10" : "",
            error ? "border-red-500 focus:ring-red-500" : "",
            className
          )}
          {...props}
        />
      </div>
        {error && (
        <p className="mt-2 text-sm text-red-600">
          {error}
        </p>
      )}
      
      {help && !error && (
        <p className="mt-1 text-sm text-gray-500">
          {help}
        </p>
      )}
    </div>
  );
};

export default Input;